var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/taccuino/nuovo_dolore_bianco.png';
import _imports_1 from '@/assets/images/taccuino/nuovo_dolore_verde.png';
import _imports_2 from '@/assets/images/taccuino/dolore_blu.png';
import _imports_3 from '@/assets/images/taccuino/dolore_viola.png';
import _imports_4 from '@/assets/images/taccuino/dolore_porpora.png';
import _imports_5 from '@/assets/images/taccuino/dolore_rosso.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-96d1cf00"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "container" };
var _hoisted_2 = { class: "canvas" };
var _hoisted_3 = { class: "penelli" };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_1 }, null, -1); });
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_2 }, null, -1); });
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_3 }, null, -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_4 }, null, -1); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_5 }, null, -1); });
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("i", { class: "icon-eraser icon-2x" }, null, -1); });
var _hoisted_12 = { class: "notes" };
var _hoisted_13 = { class: "notes-descrizione" };
var _hoisted_14 = { class: "notes-data" };
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("i", { class: "icon-eraser icon-2x" }, null, -1); });
var _hoisted_16 = { class: "omino" };
import { ref, onMounted } from "vue";
import { patientStore } from "@/store/patient";
import { authStore } from "@/store/authorize";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { getTaccuinoImage } from "@/../../EshJSLib/services/taccuinoService";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CanvasTemplate',
    emits: ["canvasElement", "onSave", "onReset"],
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, emit = _a.emit;
        var canvasElement = ref();
        var canvasBackElement = ref();
        var ctx = ref();
        var ctxBack = ref();
        var store = patientStore();
        var auth = authStore();
        var patient = storeToRefs(store).patient;
        var router = useRouter();
        var route = useRoute();
        var showLoading = ref(false);
        var editing = ref(null);
        var canvasData;
        var canvasDataBack;
        function getCurrentCanvas(e) {
            var currentCanvas = canvasData;
            if (e.currentTarget.id === 'back') {
                currentCanvas = canvasDataBack;
            }
            return currentCanvas;
        }
        function drawLine(data, x2, y2) {
            var ctx = data.canvasContext;
            ctx.beginPath();
            ctx.lineWidth = data.style.lineWidth;
            ctx.lineCap = "round";
            ctx.strokeStyle = color.value;
            ctx.lineWidth = data.style.lineWidth;
            ctx.moveTo(data.x, data.y);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        }
        function beginDrawing(e) {
            var currentCanvas = getCurrentCanvas(e);
            currentCanvas.x = e.offsetX;
            currentCanvas.y = e.offsetY;
            currentCanvas.isDrawing = true;
        }
        function keepDrawing(e) {
            var currentCanvas = getCurrentCanvas(e);
            if (currentCanvas && currentCanvas.isDrawing === true) {
                drawLine(currentCanvas, e.offsetX, e.offsetY);
                currentCanvas.x = e.offsetX;
                currentCanvas.y = e.offsetY;
                currentCanvas.canvasContext.drawImage(currentCanvas.images.canvasImageElementOutline, 0, 0, canvasElement.value.width, canvasElement.value.height);
            }
        }
        function stopDrawing(e) {
            var currentCanvas = getCurrentCanvas(e);
            if (currentCanvas.isDrawing && currentCanvas.isDrawing === true) {
                drawLine(currentCanvas, e.offsetX, e.offsetY);
                currentCanvas.x = 0;
                currentCanvas.y = 0;
                currentCanvas.isDrawing = false;
            }
        }
        var color = ref("white");
        var routeId = ref(null);
        var selectedId = route.params.id;
        var rowValue = patient.value.tbl_taccuinos.find(function (taccuino) { return taccuino.id_taccuino === Number(selectedId) || 0; });
        var todayDate = new Date().toISOString().substr(0, 10);
        if (rowValue == null) {
            rowValue = {};
            rowValue.id_taccuino = 0;
            rowValue.id_paziente = patient.value.id_paziente;
            rowValue.author_id = patient.value.id_paziente;
            rowValue.taccuino_2d_drawn = 1;
            rowValue.taccuino_data = todayDate;
        }
        var addItems = ref([]);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                ctx.value = ((_a = canvasElement.value) === null || _a === void 0 ? void 0 : _a.getContext("2d")) || undefined;
                ctxBack.value = ((_b = canvasBackElement.value) === null || _b === void 0 ? void 0 : _b.getContext("2d")) || undefined;
                canvasData = { x: 0, y: 0, isDrawing: false, canvasContext: ctx.value, images: { canvasImageElement: new Image(), canvasImageElementOutline: new Image() }, style: null, canvasElement: canvasElement.value };
                canvasDataBack = { x: 0, y: 0, isDrawing: false, canvasContext: ctxBack.value, images: { canvasImageElement: new Image(), canvasImageElementOutline: new Image() }, style: null, canvasElement: canvasBackElement.value };
                getImages(rowValue).then(function () {
                    prepareCanvas();
                });
                return [2 /*return*/];
            });
        }); });
        //TEMPLATE MODEL 2D
        function prepareCanvas() {
            console.log("Canvas: .. . prepareCanvas");
            canvasData.style = { backgroundColor: "#ffffff", brushColor: "#ffffff", lineWidth: 5 };
            canvasDataBack.style = { backgroundColor: "#ffffff", brushColor: "#ffffff", lineWidth: 5 };
            if (route.params.id === 'Nuova') {
                canvasData.images.canvasImageElement.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_front.png');
                canvasDataBack.images.canvasImageElement.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_back.png');
                canvasData.images.canvasImageElementOutline.onload = function () { return preloadImage(canvasData, false); };
                canvasDataBack.images.canvasImageElementOutline.onload = function () { return preloadImage(canvasDataBack, false); };
            }
            canvasData.images.canvasImageElementOutline.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_front_.png');
            canvasDataBack.images.canvasImageElementOutline.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_back_.png');
            if (route.params.id !== 'Nuova') {
                preloadImage(canvasData, true);
                preloadImage(canvasDataBack, true);
            }
        }
        function preloadImage(data, edit) {
            // canvas.width = 419;
            //canvas.height = 866;
            if (edit) {
                data.canvasContext.drawImage(data.images.canvasImageElement, 0, 0, data.canvasElement.width, data.canvasElement.height);
                editing.value = true;
            }
            else {
                data.canvasContext.drawImage(data.images.canvasImageElementOutline, 0, 0, data.canvasElement.width, data.canvasElement.height);
                data.canvasContext.fillStyle = data.style.backgroundColor;
                data.canvasContext.fillRect(0, 0, data.canvasElement.width, data.canvasElement.height);
                data.canvasContext.drawImage(data.images.canvasImageElementOutline, 0, 0, data.canvasElement.width, data.canvasElement.height);
                editing.value = false;
            }
        }
        function getImages(row) {
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            if (rowValue.id_taccuino == 0)
                                return [2 /*return*/];
                            showLoading.value = true;
                            return [4 /*yield*/, getTaccuinoImage(row.id_taccuino).then(function (result) {
                                    showLoading.value = false;
                                    var rowValue = patient.value.tbl_taccuinos.find(function (taccuino) { return taccuino.id_taccuino === Number(result.id_taccuino); });
                                    rowValue.taccuino_report_anteriore = result.taccuino_report_anteriore;
                                    rowValue.taccuino_report_posteriore = result.taccuino_report_posteriore;
                                    canvasData.images.canvasImageElement.src = rowValue.taccuino_report_anteriore;
                                    canvasDataBack.images.canvasImageElement.src = rowValue.taccuino_report_posteriore;
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error fetching image:", error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function saveTaccuino() {
            var _a, _b;
            rowValue.taccuino_report_anteriore = (_a = canvasElement.value) === null || _a === void 0 ? void 0 : _a.toDataURL();
            rowValue.taccuino_report_posteriore = (_b = canvasBackElement.value) === null || _b === void 0 ? void 0 : _b.toDataURL();
            emit('onSave', rowValue);
        }
        function color_dolore(colore) {
            color.value = colore;
            console.log("change color " + colore);
        }
        function erase_dolore() {
            preloadImage(canvasData, editing.value);
            preloadImage(canvasDataBack, editing.value);
        }
        function cancella_tutto() {
            ctx.value.fillStyle = canvasData.style.backgroundColor;
            ctx.value.fillRect(0, 0, canvasElement.value.width, canvasElement.value.height);
            ctxBack.value.fillStyle = canvasData.style.backgroundColor;
            ctxBack.value.fillRect(0, 0, canvasElement.value.width, canvasElement.value.height);
            ctx.value.drawImage(canvasData.images.canvasImageElement, 0, 0, canvasElement.value.width, canvasElement.value.height);
            ctxBack.value.drawImage(canvasDataBack.images.canvasImageElement, 0, 0, canvasElement.value.width, canvasElement.value.height);
        }
        function selectColor(color) {
            color.value = color;
        }
        __expose({ erase_dolore: erase_dolore });
        return function (_ctx, _cache) {
            var _component_AlertModal = _resolveComponent("AlertModal");
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (color_dolore('#ffffff')); })
                        }, [
                            _hoisted_4,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Nessun dolore")), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (color_dolore('#00ff00')); })
                        }, [
                            _hoisted_5,
                            _createTextVNode(_toDisplayString(_ctx.$t('Dolore lieve')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (color_dolore('#2323d2')); })
                        }, [
                            _hoisted_6,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('Dolore moderato')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                            onClick: _cache[3] || (_cache[3] = function ($event) { return (color_dolore('#8a2070')); })
                        }, [
                            _hoisted_7,
                            _createTextVNode(_toDisplayString(_ctx.$t('Dolore intenso')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                            style: { "text-align": "center" },
                            onClick: _cache[4] || (_cache[4] = function ($event) { return (color_dolore('#7a0026')); })
                        }, [
                            _hoisted_8,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('Dolore forte')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                            style: { "text-align": "center" },
                            onClick: _cache[5] || (_cache[5] = function ($event) { return (color_dolore('#ff0000')); })
                        }, [
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('Dolore molto forte')), 1)
                        ]),
                        _hoisted_10,
                        _createElementVNode("div", null, [
                            _createElementVNode("button", {
                                class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
                                onClick: _cache[6] || (_cache[6] = function ($event) { return (erase_dolore()); })
                            }, [
                                _hoisted_11,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('Cancella i cambiamenti')), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_unref(rowValue).taccuino_descrizione) = $event); }),
                                placeholder: 'Inserisci la descrizione'
                            }, null, 512), [
                                [_vModelText, _unref(rowValue).taccuino_descrizione]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((_unref(rowValue).taccuino_data) = $event); })
                            }, null, 512), [
                                [_vModelText, _unref(rowValue).taccuino_data]
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                    class: "mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                                    onClick: saveTaccuino
                                }, _toDisplayString(_ctx.$t('Salva')), 1),
                                _createElementVNode("button", {
                                    class: "mt-4 text-white bg-red-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-red-800",
                                    onClick: _cache[9] || (_cache[9] = function ($event) { _unref(router).push("/Registro/Taccuino"); })
                                }, [
                                    _hoisted_15,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Annulla')), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", null, [
                            _createElementVNode("canvas", {
                                ref_key: "canvasElement",
                                ref: canvasElement,
                                width: "419",
                                height: "866",
                                id: "front",
                                onMousedown: beginDrawing,
                                onMousemove: keepDrawing,
                                onMouseup: stopDrawing,
                                onTouchstart: beginDrawing,
                                onTouchmove: keepDrawing,
                                onTouchend: stopDrawing
                            }, null, 544)
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("canvas", {
                                ref_key: "canvasBackElement",
                                ref: canvasBackElement,
                                width: "419",
                                height: "866",
                                id: "back",
                                onMousedown: beginDrawing,
                                onMousemove: keepDrawing,
                                onMouseup: stopDrawing,
                                onTouchstart: beginDrawing,
                                onTouchmove: keepDrawing,
                                onTouchend: stopDrawing
                            }, null, 544)
                        ])
                    ])
                ]),
                _createVNode(_component_AlertModal, { ref: "alertModal" }, null, 512),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
